const dispatch = require("../../store.js").dispatch;
const Server = require("../../Server.js");
const parseWithRefs = require("@247grad/system-text-json-refs").parseWithRefs

const CauditActions = require("../../actions/metadata/CauditActions.js");

const CauditActionCreators = {
    LoadTargets() {
        dispatch({
            type: CauditActions.LoadTargets
        });

        dispatch((thunkDispatch) => {
            thunkDispatch({
                type: CauditActions.LoadTargets
            });

            Server.Get("caudit-target/current-user")
                .then((response) => {
                    return response.text();
                })
                .then((text) => {
                    thunkDispatch({
                        type: CauditActions.LoadedTargets,
                        Data: parseWithRefs(text)
                    });
                })
                .catch((ex) => {
                    thunkDispatch({
                        type: CauditActions.LoadTargetsErrored,
                        Error: ex
                    });
                });
        });
    },
    SelectTarget(target) {
        dispatch({
            type: CauditActions.TargetSelected,
            Target: target
        });
    }
};

module.exports = CauditActionCreators;


// WEBPACK FOOTER //
// ./src/actionCreators/metadata/CauditActionCreators.js